import { RotatingLines } from 'react-loader-spinner';

const MsalLoadingComponent = () => {
	return (
		<div className='center'>
			<RotatingLines
    	    	strokeColor="#152E54"
        	    strokeWidth="3"
	            animationDuration="1.0"
    	        width="48"
        	    visible={true}
        	/>
		</div>
	)
}

export default MsalLoadingComponent
